import { get_token, get_user_details } from "@/router";
import Swal from "sweetalert2";

export default {
  props: {
    event_id: {
      type: [Number, String],
      default: null,
    },
    event: {
      type: Object,
      default: null,
    },
    inline: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return ({
      discount_types: [],
      isLoading: false,
      new_promo_code_name: "",
      discount_type: "",
      discount_value: 0,
      start_date: this.get_date_time_local_string(new Date()),
      end_date: this.get_date_time_local_string(new Date()),
      usage_limit: 0,
      is_active: true,
      promo_errors: {},
      event_promo_codes: [],
      promo_codes: [],
      is_editing: false,
      editing_id: null,
      event_promo_code_id: null,
      user_events:[],
      user_details: null,
      selected_event_id:'',
      selected_link_promo_id: "",
      is_editing_event_promo: false,
      editing_event_promo_code_id: null,
      return_to_promo_manager: false,
      show_discount_value_dropdown: false,
      is_loading: false,
    });
  },
  computed: {
    filtered_discount_values() {
    const query = String(this.discount_value).toLowerCase().trim();
    const matchingPromos = (this.promo_codes).filter(promo => {
      return promo?.promo_code_type?.id === this.discount_type;
    });
    const values = matchingPromos
      .map(p => String(p?.discount_amount))
    const uniqueValues = [...new Set(values)];
    if (!query) return uniqueValues;
    return uniqueValues.filter(val => val.toLowerCase().includes(query));
  }
  },
  mounted() {
    if(get_token()){
      this.fetch_discount_types();
      this.fetch_event_promo_codes();
      this.user_details = get_user_details();
    }
  },
  watch: {
    event_id: {
      handler(newVal) {
        if (newVal) {
          this.fetch_event_promo_codes();
          this.get_user_promo_codes();
        }
      },
      immediate: true,
    },
    event: {
      handler(newVal) {
        if (!this.inline) return;
        if (newVal && typeof newVal === "object") {
          this.init_inline(newVal);
        }
      },
      immediate: true,
      deep: false,
    },
  },
  methods: {
    init_inline(event) {
      if (!this.inline) return;
      if (event?.id) {
        this.selected_event_id = String(event.id);
      } else if (this.event_id) {
        this.selected_event_id = String(this.event_id);
      }
      this.fetch_event_promo_codes();
      this.get_user_promo_codes();
    },
    open_promo_code_manager_modal(event = null) {
      if (event?.id) {
        this.selected_event_id = String(event.id);
      }
      this.return_to_promo_manager = false;
      if (!this.inline) {
        $("#promo_code_manager_modal").modal("show");
      }
    },
    close_child_modal() {
      this.reset_form();
      if (this.return_to_promo_manager) {
        this.return_to_promo_manager = false;
        $("#promo_code_manager_modal").modal("show");
      }
    },
    open_child_modal(modal_id) {
      this.return_to_promo_manager = true;
      $("#promo_code_manager_modal").modal("hide");
      $(modal_id).modal("show");
    },
    open_edit_promo_code_modal(promo) {
      this.promo_errors = {};
      this.reset_form();
      this.is_editing_event_promo = true;
      this.editing_id = promo.id;
      this.event_promo_code_id = promo.id;
      this.new_promo_code_name = promo.promo_code_name;
      this.discount_type = promo.promo_code_type.id;
      this.discount_value = promo.discount_amount;
      this.open_child_modal("#create_promo_code_modal");
    },
    submit_form() {
      if (this.is_editing_event_promo) {
        this.update_event_promo_code();
      } else {
        this.link_event_promo_code();
      }
    },
    reset_form() {
      this.new_promo_code_name = "";
      this.discount_type = this.discount_types?.[0].id;
      this.discount_value = 0;
      this.start_date = null;
      this.end_date = null;
      this.usage_limit = 0;
      this.is_active = true;
      this.selected_event_id = "";
      this.selected_link_promo_id = "";
      this.is_editing_event_promo = false;
      this.editing_event_promo_code_id = null;
      this.show_discount_value_dropdown = false;
    },
    fetch_discount_types() {
      this.isLoading = true;
      this.token_exists = get_token();
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/get_promo_code_types/`,
        method: "GET",
        headers: this.token_exists
          ? {
              Authorization: `Token ${this.getToken()}`,
              "Content-Type": "application/json",
            }
          : {},
        success: (response) => {
          this.discount_types = response.data.map((type) => ({
            id: type.id,
            value: type.id,
            label: type.name.charAt(0).toUpperCase() + type.name.slice(1),
          }));
          this.discount_type = this.discount_types?.[0].id;
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    },
    getToken() {
      return get_token();
    },
    fetch_event_promo_codes() {
      this.isLoading = true;
      this.token_exists = get_token();
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/get_promo_codes/`,
        method: "GET",
        headers: {
          Authorization: `Token ${this.getToken()}`,
          "Content-Type": "application/json",
        },
        success: (response) => {
          this.promo_codes = response.data;
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    },
    get_date_time_local_string(date = new Date()) {
    const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      // Returns: "2026-03-10T15:45"
      return `${year}-${month}-${day}T${hours}:${minutes}`;
    },
    open_link_promo_code_modal(promo_code = null) {
      this.open_child_modal("#link_promo_code_modal");
      this.promo_errors = {};
      this.is_editing_event_promo = false;
      this.editing_event_promo_code_id = null;
      this.start_date = this.get_date_time_local_string(new Date());
      this.end_date = this.get_date_time_local_string(new Date());

      if (promo_code?.id) {
        this.selected_link_promo_id = String(promo_code.id);
        this.editing_id = promo_code.id;
        this.discount_type = promo_code?.promo_code_type?.id ?? this.discount_type;
        this.discount_value = promo_code?.discount_amount ?? this.discount_value;
      } else {
        this.selected_link_promo_id = "";
        this.editing_id = null;
        this.discount_type = this.discount_types?.[0]?.id ?? "";
        this.discount_value = 0;
      }
    },
    open_edit_event_promo_code_modal(event_promo) {
      this.open_child_modal("#link_promo_code_modal");
      this.promo_errors = {};
      this.is_editing_event_promo = true;
      this.editing_event_promo_code_id = event_promo?.id ?? null;

      this.selected_link_promo_id = String(event_promo?.promo_code?.id ?? "");
      this.editing_id = event_promo?.promo_code?.id ?? null;
      this.discount_type = event_promo?.promo_code?.promo_code_type?.id ?? this.discount_type;
      this.discount_value = event_promo?.promo_code?.discount_amount ?? this.discount_value;

      this.start_date = event_promo?.valid_start_date
        ? this.get_date_time_local_string(new Date(event_promo.valid_start_date))
        : this.get_date_time_local_string(new Date());
      this.end_date = event_promo?.valid_end_date
        ? this.get_date_time_local_string(new Date(event_promo.valid_end_date))
        : this.get_date_time_local_string(new Date());

      this.usage_limit = event_promo?.has_usage_limit
        ? Number(event_promo?.usage_limit ?? 0)
        : 0;
      this.is_active = !!event_promo?.is_active;
    },
    validate_promo_code_form(){
      const startTimestamp = new Date(this.start_date).getTime();
      const endTimestamp = new Date(this.end_date).getTime();
      let isValid = true;
      this.promo_errors = {};
      if(!this.start_date || this.start_date.trim() === ""){
        this.promo_errors["start_date"] = "Event start data is required.";
        isValid = false;
      }
      if(!this.end_date || this.end_date.trim() === ""){
        this.promo_errors["end_date"] = "Event end data is required.";
        isValid = false;
      }
      if(endTimestamp <= startTimestamp){
        this.promo_errors["end_date"] = "End date must be greater than the start date.";
        isValid = false;
      }
       let percentage_type = this.discount_types.find(
        (type) => type.label === "Percentage",
      );
      if (!this.discount_type) {
        this.promo_errors["discount_type"] = "Discount type is required.";
        isValid = false;
      }
      const val = parseFloat(this.discount_value);
      if (this.discount_value === "" || isNaN(val) || this.discount_value <= 0) {
        this.promo_errors["discount_value"] =
          "Discount value cannot be less than 0.";
        isValid = false;
      }
      if (this.discount_type === percentage_type.id) {
        const value = parseFloat(this.discount_value);
        if (isNaN(value) || value <= 0) {
          this.promo_errors["discount_value"] =
            "Percentage must be greater than 0.";
          isValid = false;
        } else if (value > 100) {
          this.promo_errors["discount_value"] =
            "Percentage cannot exceed 100%.";
          isValid = false;
        }
      }
      return isValid;
    },
    link_event_promo_code(promo_id) {
      if(!this.validate_promo_code_form()) return;
      const payload = {
        promo_code_id: promo_id,
        event_id: this.event_id ?? this.selected_event_id,
        start_date: this.start_date,
        end_date: this.end_date,
        usage_limit: String(this.usage_limit),
        is_active: this.is_active,
        has_usage_limit: this.usage_limit > 0 ? true : false,
        promo_code_type_id: this.discount_type,
        discount_amount: this.discount_value,
      };
      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/link_event_promo_code/`,
        data: JSON.stringify(payload),
        processData: true,
        contentType: "application/json",
        headers: {
          Authorization: `Token ${this.getToken()}`,
        },
        success: (response) => {
          if (response.status === "success") {
            Swal.fire({
              icon: "success",
              title: "Promo Code Successfully linked to an Event",
              text: response.message,
              showConfirmButton: false,
              timer: 2000,
              position: 'bottom-end',
              toast: true
            }).then(() => {
              $("#link_promo_code_modal").modal("hide");
              this.event_promo_codes.unshift(response.data);
              this.reset_form();
              if (this.return_to_promo_manager) {
                this.return_to_promo_manager = false;
                $("#promo_code_manager_modal").modal("show");
              }
              this.$emit("promo-updated", response.data);
            });
          }
        },
        error: (response) => {
          Swal.close();
          const response_data = response.responseJSON || {};
          Swal.fire({
            icon: "error",
            title: "Error",
            text:
              response_data.message ||
              "An error occurred while Linking Promo code, please try again.",
            showConfirmButton: false,
            timer: 3000,
            position: 'bottom-end',
            toast: true
          });
        },
      });
    },
    update_event_promo_code(promo_id) {
      if(!this.validate_promo_code_form()) return;
      const payload = {
        event_promo_code_id: this.editing_event_promo_code_id,
        promo_code_id: promo_id,
        event_id: this.event_id ?? this.selected_event_id,
        start_date: this.start_date,
        end_date: this.end_date,
        usage_limit: String(this.usage_limit),
        is_active: this.is_active,
        has_usage_limit: this.usage_limit > 0 ? true : false,
        promo_code_type_id: this.discount_type,
        discount_amount: this.discount_value,
      };

      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/update_event_promo_code/`,
        data: JSON.stringify(payload),
        processData: true,
        contentType: "application/json",
        headers: {
          Authorization: `Token ${this.getToken()}`,
        },
        success: (response) => {
          if (response.status === "success") {
            Swal.fire({
              icon: "success",
              title: "Promo Code Link Updated",
              text: response.message,
              showConfirmButton: false,
              timer: 2000,
              position: 'bottom-end',
              toast: true
            }).then(() => {
              const index = this.event_promo_codes.findIndex(
                (ep) => String(ep.id) === String(this.editing_event_promo_code_id),
              );
              if (index !== -1) {
                this.event_promo_codes.splice(index, 1, response.data);
              }
              $("#link_promo_code_modal").modal("hide");
              this.reset_form();
              if (this.return_to_promo_manager) {
                this.return_to_promo_manager = false;
                $("#promo_code_manager_modal").modal("show");
              }
            });
          }
        },
        error: (response) => {
          Swal.close();
          const response_data = response.responseJSON || {};
          Swal.fire({
            icon: "error",
            title: "Error",
            text:
              response_data.message ||
              "An error occurred while updating promo code link, please try again.",
            showConfirmButton: false,
            timer: 3000,
            position: 'bottom-end',
            toast: true
          });
        },
      });
    },
    get_user_promo_codes(){
      this.is_loading=true;
      const payload = {
       event_id: this.event_id ?? this.selected_event_id,
      }
      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/get_user_event_promo_codes/`, // Update your URL
        data: JSON.stringify(payload),
        processData: true,
        contentType: "application/json",
        headers: {
          Authorization: `Token ${this.getToken()}`,
        },
        success: (response) => {
          if (response.status === "success") {
            $("#link_promo_code_modal").modal("hide");
            this.event_promo_codes= response.data;
            this.is_loading=false;
          }
        },
      });
    },
    toggle_promo_status(event_promo) {
      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/toggle_event_promo_status/`,
        data: JSON.stringify({
          event_promo_code_id: event_promo.id,
        }),
        headers: {
          Authorization: `Token ${this.getToken()}`,
          "Content-Type": "application/json",
        },
        success: (response) => {
          if (response.status === "success") {
            this.event_promo_codes.forEach(ep => {
              if(ep.id == event_promo.id){
                ep.is_active = response.data.is_active;
              }
            });
          }
        }
      });
    },
    delete_event_promo_code(event_promo) {
      Swal.fire({
        title: "Are you sure?",
        text: "You want to delete this promo code?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        position: 'bottom-end',
        toast: true
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            type: "POST",
            url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/delete_event_promo_code/`,
            data: JSON.stringify({
              event_promo_code_id: event_promo.id,
            }),
            headers: {
              Authorization: `Token ${this.getToken()}`,
              "Content-Type": "application/json",
            },
            success: (response) => {
              if (response.status === "success") {
                Swal.fire({
                  icon: "success",
                  title: "Promo Code Successfully deleted",
                  text: response.message,
                  showConfirmButton: false,
                  timer: 2000,
                  position: 'bottom-end',
                  toast: true
                }).then(() => {
                  this.event_promo_codes = this.event_promo_codes.filter(
                    (ep) => ep.id !== event_promo.id
                  );
                  this.$emit("promo-deleted", event_promo.id);
                });
              }
            },
            error: (response) => {
              Swal.close();
              const response_data = response.responseJSON || {};
              Swal.fire({
                icon: "error",
                title: "Error",
                text:
                  response_data.message ||
                  "An error occurred while deleting promo code, please try again.",
                showConfirmButton: false,
                timer: 3000,
                position: 'bottom-end',
                toast: true
              });
            },
          });
        }
      });
    },
    isPromoValid(startDateStr, endDateStr) {
    const now = new Date();
    const start = new Date(startDateStr);
    const end = new Date(endDateStr);
    if (isNaN(start) || isNaN(end)) {
      console.error("Invalid date format provided");
      return false;
    }
    return now >= start && now <= end;
  },
  },
};
